(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__announcementCountdownInit) return;
    window.__announcementCountdownInit = true;

    function pad(n, leading) {
      var s = String(n);
      return leading && s.length < 2 ? ('0' + s) : s;
    }

    function initCountdown(el) {
      var deadlineStr = el.getAttribute('data-deadline') || '';
      var showDays = el.getAttribute('data-show-days') === 'true';
      var leading = el.getAttribute('data-leading-zeros') === 'true';
      var hideEnded = el.getAttribute('data-hide-when-ended') === 'true';
      var endedText = el.getAttribute('data-ended-text') || 'Finalizado';

      var daysWrap = el.querySelector('.cd-days');
      var numDays = el.querySelector('[data-cd-num="days"]');
      var numHours = el.querySelector('[data-cd-num="hours"]');
      var numMinutes = el.querySelector('[data-cd-num="minutes"]');
      var numSeconds = el.querySelector('[data-cd-num="seconds"]');

      if (!showDays && daysWrap) {
        daysWrap.hidden = true;
        var sep = daysWrap.nextElementSibling;
        if (sep && sep.classList.contains('cd-sep')) sep.hidden = true;
      }

      var deadline = new Date(deadlineStr);
      if (isNaN(deadline.getTime())) {
        // no iniciamos si no hay fecha válida
        return;
      }

      function tick() {
        var now = Date.now();
        var diff = deadline.getTime() - now;

        if (diff <= 0) {
          if (hideEnded) {
            el.hidden = true;
          } else {
            el.textContent = endedText;
          }
          clearInterval(timer);
          return;
        }

        var total = Math.floor(diff / 1000);
        var d = Math.floor(total / 86400);
        var h = Math.floor((total % 86400) / 3600);
        var m = Math.floor((total % 3600) / 60);
        var s = total % 60;

        if (numDays && showDays) numDays.textContent = pad(d, leading);
        if (numHours) numHours.textContent = pad(h, leading);
        if (numMinutes) numMinutes.textContent = pad(m, leading);
        if (numSeconds) numSeconds.textContent = pad(s, leading);
      }

      tick();
      var timer = setInterval(tick, 1000);
    }

    function boot() {
      document.querySelectorAll('[data-countdown]').forEach(initCountdown);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  }());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["swatches"] && !Shopify.designMode) return;
  try {
    function bindSwatchClick(swatchEl) {
    if (swatchEl.dataset.clickBound) return;
    swatchEl.dataset.clickBound = 'true';

    swatchEl.addEventListener('click', (e) => {
      const input = e.target.closest('input[type="radio"]');
      if (!input) return;

      e.stopPropagation();

      const picker = swatchEl.closest('swatches-variant-picker-component');
      const productUrl = picker?.getAttribute('data-product-url');
      const variantId = input.dataset.variantId;

      // Marcar el radio y disparar change manualmente (fix Firefox)
      if (!input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (productUrl && variantId) {
        const url = new URL(productUrl, window.location.origin);
        url.searchParams.set('variant', variantId);
        window.location.href = url.toString();
      }
    });
  }

  document.querySelectorAll('product-swatches').forEach(bindSwatchClick);

  new MutationObserver(() => {
    document.querySelectorAll('product-swatches:not([data-click-bound])').forEach(bindSwatchClick);
  }).observe(document.body, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

})();
